const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/InvoicePage/InvoicePage.tsx';
import { RouteComponentProps } from 'react-router';
import textMap from './translations';
import LoadingSpinner from '@cistec/common_web/components/LoadingSpinner';
import { sortObjectsByPath } from '@cistec/common_web/utils/data';
import { EmptyState } from 'App/components/EmptyState/EmptyState';
import * as React from 'react';
import { useMemo } from 'react';
import { InvoiceList } from './InvoiceList';
import { Page } from '../Page';
import { IconClass } from '@cistec/common_web/defs/icons';
import { useInvoices } from 'App/store/documents';
import _ from 'lodash';

export const InvoicePage = (props: RouteComponentProps) => {
    const { data: invoices, isPendingOrLoading: isLoadingInvoices } = useInvoices();

    const sortedInvoices = useMemo(() => {
        if (invoices) {
            return _.clone(invoices).sort(sortObjectsByPath('DAT', true));
        }
        return undefined;
    }, [invoices]);

    const renderContent = () => {
        if (isLoadingInvoices) {
            return <LoadingSpinner center="absolute" delay={300} />;
        }
        if (sortedInvoices?.length) {
            return <InvoiceList reports={sortedInvoices} />;
        }
        return (
            <div>
                <EmptyState intlText={textMap.noInvoices} />
            </div>
        );
    };

    return (
        <Page title={textMap.cardTitle} iconClass={IconClass.Document}>
            {renderContent()}
        </Page>
    );
};
